import React from 'react'
import { View } from 'react-native'

import Screen from '../../../components/Screen'
import { defaultStyles } from '../../../config/styles'
import TitleGraphic from '../../../components/TitleGraphic'
import useCriticalImpactOpportunity from '../../../hooks/useCriticalImpactOpportunity'
import { AnythingAdd } from './components/AnythingAdd'

export default function FormPauseScreen() {
  const cioId: string = useCriticalImpactOpportunity()

  return (
    <Screen style={defaultStyles.screen}>
      <TitleGraphic
        section="Critical Impact Opportunities"
        title="Create a CIO"
        graphic={require('../../../assets/lead-cio.jpg')}
      />
      <View style={defaultStyles.mainContainer}>
        <AnythingAdd cioId={cioId} />
      </View>
    </Screen>
  )
}
